import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import LongRangeMoversWrapper from "@components/layouts/longrangemoversWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function PrivacyPolicyPage(): ReactElement {
    return (
        <LongRangeMoversWrapper>
            <section className="max-w-7xl mx-auto">
                <PrivacyPolicy category="Moving" domain="LongRangeMovers.com" />
            </section>
        </LongRangeMoversWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
